import React from "react";
import MainBanner from "./MainBanner";
import { Card } from "react-bootstrap";
import DealDay from "./DealDay";

function Home() {
  return (
    <div>
      <div
        style={{
          borderTop: "1px solid #e8491d",
          // borderBottom: "10px solid #e8491d",
        }}
      >
        <MainBanner />
      </div>
      <div className="container my-3">
        <div style={{ backgroundColor: "red" }}>
          <div className="text-center text-white p-3 ">
            <p className="m-0">This Site Is For Only Testing Purpose !!!</p>
            <p className="m-0">
              Everything Here You See For Shoping Is Fake !!!
            </p>
            <p className="m-0">
              If Anyone Has Problem With Any Content That I Have Used In This
              Website Please Contact Me At{" "}
              <span className="text-decoration-underline">
                <a
                  href="mailto:chauhanshubham592@gmail.com"
                  className="text-white"
                >
                  chauhanshubham592@gmail.com
                </a>
              </span>{" "}
              I Will Remove It !!!
            </p>
          </div>
        </div>
        <div className="mt-3">
          <img
            className="img-fluid"
            src={process.env.PUBLIC_URL + "/images/sale3.jpg"}
            alt="..."
          />
        </div>
        <div className="mt-3">
          <Card className="shadow-lg">
            <Card.Header className="shadow-lg">
              <p className="h5 fw-bolder text-danger">Deal Of The Day</p>
            </Card.Header>
            <Card.Body>
              <DealDay />
            </Card.Body>
          </Card>
        </div>
      </div>
      <div className="my-4">
        <img
          className="img-fluid"
          src={process.env.PUBLIC_URL + "/images/mbanner1.jpg"}
          alt="..."
        />
      </div>
    </div>
  );
}

export default Home;
